import styled from '@emotion/styled'
import { MultiButton, MultiButtonProps } from './MultiButton'
import * as constants from 'view/styles/constants'

export const LinkButton = styled(MultiButton)<MultiButtonProps>`
  color: ${props => (props.disabled ? constants.CORE_PRIMARY_5 : constants.CORE_PRIMARY_6)};
  font-weight: ${constants.FontWeight.SemiBold};
  font-size: 12px;
  &:hover {
    color: ${constants.CORE_PRIMARY_7};
    text-decoration: underline;
  }
`
